/**
 * UserIcon — sanitized from `assets/newSvg/user.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function UserIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M12,13 C14.3955,13 16.5753,13.6937 18.1777,14.6715 C18.9786,15.1602 19.6621,15.7363 20.156,16.3615 C20.642,16.9767 21,17.713 21,18.5 C21,19.3449 20.5889,20.0111 19.9973,20.4859 C19.4368,20.9359 18.6982,21.2336 17.9128,21.4416 C16.3353,21.8593 14.229,22 12,22 C9.77101,22 7.66466,21.8593 6.08716,21.4416 C5.30182,21.2336 4.56324,20.9359 4.00266,20.4859 C3.41114,20.0111 3,19.3449 3,18.5 C3,17.713 3.35805,16.9767 3.84397,16.3615 C4.33788,15.7363 5.02143,15.1602 5.82227,14.6715 C7.42467,13.6937 9.60453,13 12,13 Z M12,2 C14.7614,2 17,4.23858 17,7 C17,9.76142 14.7614,12 12,12 C9.23858,12 7,9.76142 7,7 C7,4.23858 9.23858,2 12,2 Z"
        fill={color}
      />
    </Svg>
  );
}

export default UserIcon;
